import { useEffect } from 'react';

// Enter in a field of several lines is a new line there, not "save" or "go on".
const isMultiLine = (target) => Boolean(target)
  && (target.tagName === 'TEXTAREA' || target.isContentEditable === true);

function useEnterKey(handleSaveInfo) {
  useEffect(() => {
    const onKey = e => {
      if (e.keyCode === 13 && !isMultiLine(e.target)) {
        handleSaveInfo();
      }
    }

    window.addEventListener('keyup', onKey);

    return () => window.removeEventListener('keyup', onKey);
  });
}

export { useEnterKey, isMultiLine };